import { useMemo } from 'react'

import type { SearchSchoolResponseSchoolSubscription } from '@services/SchoolService'

export const SeatCountCell = ({
    schoolSubscriptions
}: {
    schoolSubscriptions: SearchSchoolResponseSchoolSubscription[]
}) => {
    const count = useMemo(() => {
        return schoolSubscriptions.reduce((collector: number, ss) => {
            return collector + ss.seatCount
        }, 0)
    }, [...schoolSubscriptions])

    return <>{count}</>
}
